"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var authentication_1 = require("@dynamynd/authentication");

var components_lib_1 = require("@dynamynd/components-lib");

var content_1 = require("@dynamynd/content");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var sharing_1 = require("@dynamynd/sharing");

var survey_1 = require("@dynamynd/survey");

var user_1 = require("@dynamynd/user");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var components_1 = require("../../components");

var store_1 = require("../../store");

var ContactUsScreen =
/** @class */
function (_super) {
  __extends(ContactUsScreen, _super);

  function ContactUsScreen(props) {
    var _this = _super.call(this, props) || this;

    _this.getTitleText = function () {
      var sent = _this.props.contactPageMessageStatus.sent;

      if (sent) {
        return 'Thank you';
      }

      return 'Contact Us';
    };

    _this.renderMessageSent = function () {
      // <Trademark>™</Trademark>
      return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_lib_1.ParagraphWithMargin, {
        centered: true,
        size: components_lib_1.ParagraphSizeEnum.big
      }, "Your message has been sent."), react_1.default.createElement(components_lib_1.ParagraphWithMargin, {
        centered: true,
        size: components_lib_1.ParagraphSizeEnum.large
      }, "The team will get back to you as soon as possible."));
    };

    return _this;
  }

  ContactUsScreen.prototype.componentWillUnmount = function () {
    this.props.setMessageSentStatusState({
      sent: false,
      updating: false
    });
  };

  ContactUsScreen.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        WebViewComponent = _a.screenProps.components.WebViewComponent,
        navigation = _a.navigation,
        submitMessage = _a.submitMessage,
        _b = _a.contactPageMessageStatus,
        sent = _b.sent,
        updating = _b.updating,
        userMO = _a.userMO;
    var isLoggedIn = authentication_1.authService.isAuthenticated(); /// todo move to separate component

    var isSurveyCompleted = survey_1.surveyService.isSurveyScored(userMO);
    var buttonText = "Back to " + (isLoggedIn ? "" + (isSurveyCompleted ? 'Dashboard' : 'Survey') : 'Home');
    var navigationParams = utilities_1.navigateWithAccessCodeQueryParam(navigation.getParam);
    return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
      var height = _a.height,
          activeBreakpoint = _a.activeBreakpoint;
      return react_1.default.createElement(content_1.WithAdditionalContent, {
        WebViewComponent: WebViewComponent,
        includeFooter: true
      }, function (_a) {
        var showContent = _a.showContent;
        var small = responsive_1.isSmall(activeBreakpoint);
        return react_1.default.createElement(components_lib_1.BackgroundWithLeftFloatingImage, null, react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_lib_1.Header, null, react_1.default.createElement(components_lib_1.LogoMascot, {
          activeBreakpoint: activeBreakpoint,
          color: "purple",
          version: {
            sm: 'image',
            lg: 'image'
          },
          navigationExtraParams: navigationParams
        }), isLoggedIn ? react_1.default.createElement(user_1.UserProfileBox, {
          showPrivacy: function showPrivacy() {
            return showContent(content_1.ContentPagesEnum.privacy);
          },
          showTerms: function showTerms() {
            return showContent(content_1.ContentPagesEnum.terms);
          }
        }) : small ? react_1.default.createElement(components_lib_1.ContentItemsPopup, {
          navigation: navigation,
          showPrivacy: function showPrivacy() {
            return showContent(content_1.ContentPagesEnum.privacy);
          },
          showTerms: function showTerms() {
            return showContent(content_1.ContentPagesEnum.terms);
          }
        }) : null), react_1.default.createElement(components_lib_1.ContentContainerScrollable, {
          height: height,
          activeBreakpoint: activeBreakpoint
        }, react_1.default.createElement(components_lib_1.TitleWithMargin, {
          activeBreakpoint: activeBreakpoint,
          centered: true
        }, _this.getTitleText()), sent ? _this.renderMessageSent() : react_1.default.createElement(components_1.ContactForm, {
          submitMessage: submitMessage,
          updating: updating
        }), react_1.default.createElement(components_1.ContactPageButtonRow, null, react_1.default.createElement(components_1.ContactFormButtonContainer, null, react_1.default.createElement(components_lib_1.Button, {
          type: components_lib_1.ButtonTypeEnum.secondary,
          text: buttonText,
          onPress: function onPress() {
            return navigation.navigate(routes_1.RoutesKeysEnum.home, navigationParams);
          },
          uppercase: true,
          disabled: false
        }))))));
      });
    });
  };

  return ContactUsScreen;
}(react_1.default.Component);

exports.ContactUsScreen = ContactUsScreen;

var mapStateToProps = function mapStateToProps(state) {
  return {
    userMO: user_1.userMOSelector(state),
    contactPageMessageStatus: store_1.contactPageMessageSentStatusSelector(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    submitMessage: redux_1.bindActionCreators(store_1.submitContactPageMessageActionCreator, dispatch),
    setMessageSentStatusState: redux_1.bindActionCreators(store_1.setContactPageMessageStatusActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector, sharing_1.withAddThisSharing);
exports.default = hoc(ContactUsScreen);